import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FOLDER_DIRECTORIES } from '../../../../../constants/folder';
import foldersService from '../../../../../services/folders/folders-service';
import serializeQueryParams from '../../../../../utils/url/serialize-query-params';

const useFolderRemovalObserver = (item: Material, onRemove?: (item: Material) => void): void => {
    const mutatedAt = useSelector((state: RootState) => state.main.folders[FOLDER_DIRECTORIES.WISHLIST].mutatedAt);

    useEffect(() => {
        if (!mutatedAt || !onRemove) {
            return;
        }

        foldersService
            .getFoldersByMaterialIds(FOLDER_DIRECTORIES.WISHLIST, [item.id])
            .then((result: Record<number, Folder[]>) => {
                const list: Folder[] = result[item.id] || [];
                const params = serializeQueryParams();
                const folderId = Number(params.folder);

                if (folderId && !list.some((folder) => folder.id === folderId)) {
                    onRemove(item);
                }
            });
    }, [mutatedAt]);
};

export default useFolderRemovalObserver;
